import React, { useEffect, useState } from 'react';

import { components } from '../components';
import { hooks } from '../hooks';
import { items } from '../items';
import { Routes } from '../routes';

import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { setSelectedMenuCategory } from '../store/slices/filterSlice';
import { DishType } from '../types';

export const MenuListAI: React.FC = () => {
  const dispatch = hooks.useDispatch();

  const navigate = hooks.useNavigate();

  const {menuLoading, menu} = hooks.useGetMenu();
  const {dishesLoading, dishes} = hooks.useGetDishes();

  const location = hooks.useLocation();
  const menuData = location.state;
useEffect(() => {
  if (!menuData) {
    navigate(-1); // or navigate to a fallback page like: navigate(Routes.Home)
  }
}, [menuData, navigate]);
  const [opacity, setOpacity] = useState<number>(0);
  // const [selectedCategory, setSelectedCategory] = useState<string>(menuName);
  
  const { selectedMenuCategory } =
  useSelector((state: RootState) => state.filterSlice);
  useEffect(() => {
    // Set the first menu item as selected by default
    if (!menuLoading && menu.length > 0 && selectedMenuCategory === "") {
      dispatch(setSelectedMenuCategory(menu[0].name));
    }
  }, [menuLoading, menu, dispatch, selectedMenuCategory]);
  // const filteredDishes = dishes;

  const filteredDishes = dishes?.filter((dish: DishType) => {
    return menuData.recommendedIds.includes(dish._id);
  });
  
  
  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title="Just for You 🍽️"
        showGoBack={true}
        showBasket={true}
      />
    );
  };


 
  //   if (
  //     menuLoading ||
  //     dishesLoading ||
  //     menu.length === 0 ||
  //     dishes.length === 0
  //   ) {
  //     return null;
  //   }

  //   return (
  //     <section style={{width: '100%', marginTop: 14, paddingBottom: 20}}>
  //       <Swiper
  //         spaceBetween={8}
  //         slidesPerView={'auto'}
  //         pagination={{clickable: true}}
  //         navigation={true}
  //         mousewheel={true}
  //       >
  //         {menu.map((category: MenuType, index, array) => {
  //           const isLast = index === array.length - 1;

  //           return (
  //             <SwiperSlide
  //               key={category.id}
  //               style={{
  //                 width: 'auto',
  //                 marginLeft: index === 0 ? 20 : 0,
  //                 marginRight: isLast ? 20 : 0,
  //               }}
  //               // onClick={() => setSelectedCategory(category.name)}
  //               onClick={() => dispatch(setSelectedMenuCategory(category.name))}
  //             >
  //               <div
  //                 style={{
  //                   padding: '10px 20px',
  //                   borderRadius: 10,
  //                   border: '1px solid red',
  //                   borderColor:
  //                   selectedMenuCategory === category.name
  //                       ? 'var(--main-turquoise)'
  //                       : 'var(--white-color)',
  //                   backgroundColor: 'var(--white-color)',
  //                 }}
  //               >
  //                 <h5
  //                   style={{
  //                     textTransform: 'capitalize',
  //                     color:
  //                     selectedMenuCategory === category.name
  //                         ? 'var(--main-turquoise)'
  //                         : 'var(--main-color)',
  //                   }}
  //                 >
  //                   {category.name}
  //                 </h5>
  //               </div>
  //             </SwiperSlide>
  //           );
  //         })}
  //       </Swiper>
  //     </section>
  //   );
  // };

  const renderContent = (): JSX.Element | null => {
    if (
      menuLoading ||
      dishesLoading ||
      menu.length === 0 ||
      dishes.length === 0
    ) {
      return null;
    }

    return (
      <main className='scrollable container'>
       <ul style={{ paddingBottom: 20 }}>
  {filteredDishes.map((dish: DishType, index: number, array: DishType[]) => {
    const isLast = index === array.length - 1;
   
   
    const dishReason = menuData?.recommendedDishes?.filter(
      (item: { id: number | string | undefined }) => String(item?.id) === String(dish._id)
    );
    
    return (
      <React.Fragment key={dish.id}>
        <items.MenuListItem dish={dish} isLast={isLast} fromAI={true} dishReason={dishReason[0]?.reason}/>

        {/* 💬 Per-dish Recommendation Card */}
        
         
       
      </React.Fragment>
    );
  })}
   <li
  className="mt-6 p-4 bg-white rounded-lg shadow-sm border border-gray-100 text-center"
>
  <h4 className="text-sm font-semibold text-gray-800 mb-1">
    Didn’t find something you like?
  </h4>
  <p className="text-xs text-gray-500 mb-3">
    Explore the full menu for more delicious options.
  </p>
  <button
    onClick={() => navigate(Routes.TabNavigator,{replace:true})} // ✅ update if your full menu route is different
    className="text-cyan-600 font-medium text-sm mx-auto  hover:text-cyan-700 transition"
  >
    Browse Full Menu
  </button>
</li>
</ul>

      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (
      menuLoading ||
      dishesLoading ||
      menu.length === 0 ||
      dishes.length === 0
    ) {
      return <components.Loader />;
    }
    return null;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {/* {renderSearch()} */}
    
      {renderContent()}
      {renderLoader()}
    </div>
  );
};
